// getUnlockButtonStatus.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getOperationData from '../selector/getOperationData.js';
import getMeData from '../selector/getMeData.js';
import getMessageData from '../selector/getMessageData.js';
import { drmRulesetTestStatus as drmRulesetTestStatusConstant } from '../resource/drmConstants.js';
import getRemoteConfigData from './getRemoteConfigData.js';
import { FEATURE_ANONYMOUS_LOGIN } from '../RemoteConfigKeys.js';

const getMeId = state => getMeData(state, 'id');

const getIsUnlocking = (state, messageId) =>
  getNetworkingData(state, ['messages', messageId, 'unlock'], 'isFetching');

const getIsCtaOembedFetching = (state, messageId) => {
  const ctaUrl = getMessageData(state, messageId, 'ctaUrl');
  const isFetching = getNetworkingData(state, ['oembed', ctaUrl], 'isFetching');
  return isFetching;
};
/**
 * Select unlock button status by state
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {String} messageId - select key.
 * @return {String} The selected unlock button status.
 */
const getUnlockButtonStatus = createCachedSelector(
  getMeId,
  getIsUnlocking,
  (state, messageId) =>
    getNetworkingData(
      state,
      ['drm', 'licenseAvailability', messageId],
      'isFetched'
    ),
  (state, messageId) =>
    getNetworkingData(state, ['messages', messageId, 'detail'], 'isFetching'),
  state =>
    getOperationData(state, ['drm'], 'testStatus') ===
    drmRulesetTestStatusConstant.TESTING,
  getIsCtaOembedFetching,
  state => getRemoteConfigData(state, FEATURE_ANONYMOUS_LOGIN),
  (
    meId,
    isUnlocking,
    isDrmLicenseAvailabilityFetched,
    isMessageDetailFetching,
    isBrowserDrmRulesetTesting,
    isCtaOembedFetching,
    isAnonymousLoginEnabled
  ) => {
    if (!meId && !isAnonymousLoginEnabled) return 'unauthorized';
    if (
      isUnlocking ||
      isMessageDetailFetching ||
      !isDrmLicenseAvailabilityFetched ||
      isBrowserDrmRulesetTesting ||
      isCtaOembedFetching
    ) {
      return 'loading';
    }

    return 'authorized';
  }
)((state, messageId) => `${messageId}`);

export default getUnlockButtonStatus;
